import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avatar from "@mui/material/Avatar";
import SuiInput from "components/SuiInput";
import DraggableDialog from "components/UpStyled/DraggableDialog";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";

import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckIcon from "@mui/icons-material/Check";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PeopleIcon from "@mui/icons-material/People";

import { Divider } from "antd";

import api from "services/api";

import { AccountContext } from "context/account";
import { StoreContext } from "context/store";

import { filterParser } from "utils/helper";
import { privilegeOptions } from "utils/data";
import { toast } from "react-hot-toast";
import colors from "assets/theme/base/colors";
import { keyframes } from "@emotion/react";
import pxToRem from "assets/theme/functions/pxToRem";
import typography from "assets/theme/base/typography";

const QuickShareChangeModal = ({
  item,
  user,
  type,
  handleClose,
  handleOk,
  visible,
  handleRefresh = () => {},
  permittedUsers = [],
}) => {
  const { size, fontWeightRegular } = typography;

  const [anchorEl, setAnchorEl] = useState(null);
  const [newPerm, setNewPerm] = useState(null);

  const open = Boolean(anchorEl);

  const account = useContext(AccountContext);
  const email = user?.user?.email;
  const store = user?.user?.stores && user?.user?.stores.length > 0 ? user?.user?.stores[0] : {};
  const oldPerm = privilegeOptions.find((x) => x.value == user?.privilege);

  useEffect(() => {
    const permission = privilegeOptions.find((x) => x.value == user?.privilege);
    setNewPerm(permission);
  }, []);

  const handleUpdatePermission = async (event) => {
    const email = user?.user?.email;
    const storeName = user?.user?.stores?.[0]?.name;
    if (!newPerm?.value) {
      return toast.error("Can't find the permission value!");
    }

    let payload = [
      {
        email: email,
        resource_id: item.id,
        resource_type: type,
        privilege: newPerm.value,
      },
    ];
    try {
      if (newPerm.value == 0) {
        payload = [
          {
            user_id: user?.user_id,
            resource_id: item.id,
            resource_type: type,
          },
        ];
        await api.resourcePermission.revoke({ permissions: payload }); //remove permissions if privileges=0
      } else {
        await api.resourcePermission.grant({ permissions: payload });
      }

      toast.success(`Your privileges for ${storeName || email} have been updated successfully!`);
      handleClose();
      handleRefresh();
    } catch (err) {
      console.log(err);
      toast.error(`Your privileges for ${storeName || email} could not be updated!`);
    }
  };

  const PermissionMenu = () => (
    <Menu
      id="permission-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      MenuListProps={{
        "aria-labelledby": "lock-button",
        role: "listbox",
      }}
    >
      {privilegeOptions.map((option, index) => (
        <MenuItem
          key={option.value}
          onClick={(e) => {
            setNewPerm(option);
            setAnchorEl(null);
          }}
        >
          <SuiBox display="flex" alignItems="center" justifyContent="center">
            <SuiBox sx={{ width: 30 }}>
              {newPerm?.value == option.value ? (
                <CheckIcon fontSize="small" color="success" />
              ) : null}
            </SuiBox>
          </SuiBox>
          <SuiBox>{option?.label}</SuiBox>
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <DraggableDialog
      heading={`Share "${item?.title || item?.name}"`}
      text={
        <SuiBox pt={0.5}>
          <List
            sx={{ width: "100%", maxHeight: 360, overflow: "auto", bgcolor: "background.paper" }}
          >
            <ListItemButton alignItems="flex-start">
              <ListItem
                secondaryAction={
                  <SuiButton
                    variant="text"
                    color="dark"
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                  >
                    {newPerm?.label}
                    <ArrowDropDownIcon fontSize="sm" />
                  </SuiButton>
                }
              >
                <ListItemAvatar>
                  <Avatar alt={store?.name} src={store?.metadata?.avatar} />
                </ListItemAvatar>
                <ListItemText
                  primary={store?.name}
                  secondary={
                    <React.Fragment>
                      <SuiTypography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {email}
                      </SuiTypography>
                    </React.Fragment>
                  }
                />{" "}
              </ListItem>
            </ListItemButton>
          </List>
          <SuiBox display="flex" justifyContent="flex-end" mb={-1}>
            {oldPerm?.value != newPerm?.value ? (
              <SuiTypography color="text" sx={{ ml: 4 }} variant="body1">
                Pending changes
              </SuiTypography>
            ) : null}{" "}
          </SuiBox>
          <PermissionMenu />
        </SuiBox>
      }
      visible={visible}
      handleClose={() => {
        handleClose();
      }}
      handleOk={() => {
        handleUpdatePermission();
      }}
      okText="Update"
      cancelText={"Cancel"}
      hideAction={false}
      option={{ fullWidth: true, maxWidth: "sm" }}
    />
  );
};

export default QuickShareChangeModal;
